<template>
  <div id="upsellEdit">
    <div class="container">

      <TipBox info :title="$t('tips.upsell.title')">
        <p v-html="$t('tips.upsell.description')"></p>
        <b v-html="$t('tips.upsell.description_2')"></b>
        <ul>
          <li v-html="$t('tips.upsell.li_1')"></li>
          <li v-html="$t('tips.upsell.li_2')"></li>
        </ul>
      </TipBox>

      <Tabs>
        <TabSection :title="$t('upsell.title')">
          <!-- STARTING UPSELL -->
          <div class="section">
            <div class="subtitle">{{ $t("upsell.onStart.subTitle") }}</div>
            <div class="group">
              <label>{{ $t("upsell.module") }}</label>
              <select type="text" v-model="onStartModule">
                <option :value="module" v-for="module of modules">{{ $t('upsell.modules.${module}') }}</option>
              </select>
            </div>
            <div v-if="onStartModule === 'ai'">
              <div class="group">
                <ListMultiSelect :bank="allCategories" :selected="upsell.onStart.ai.categories"
                  :bank-title="$t('upsell.available_categories')" :selected-title="$t('upsell.recommended_categories')" />
              </div>
            </div>
            <div v-if="onStartModule === 'manual'">
              <div class="group">
                <ListMultiSelect :bank="allItems" :selected="upsell.onStart.manual.items"
                  :bank-title="$t('upsell.available_items')" :selected-title="$t('upsell.recommended_items')" />
              </div>
            </div>
          </div>

          <!-- MODIFIER UPSELL -->
          <!--<div class="section">
        <div class="subtitle">{{$t("upsell.onModifiers.subTitle")}}</div>
          <div class="group">
            <label>{{ $t("upsell.onModifiers.activated") }}</label>
            <select type="text" v-model="upsell.onModifiers.activated">
              <option :value="true">{{$t('yes')}}</option>
              <option :value="false">{{$t('no')}}</option>
            </select>
          </div>
          <div class="group" v-if="upsell.onModifiers.activated">
            <ListMultiSelect
              :bank="allModifiers"
              :selected="upsell.onModifiers.modifiers"
              :bank-title="$t('upsell.onModifiers.available_modifiers')"
              :selected-title="$t('upsell.onModifiers.recommended_modifiers')"
            />
          </div>
        </div>-->

          <!-- ENDING UPSELL -->
          <div class="section">
            <div class="subtitle">{{ $t("upsell.onEnd.subTitle") }}</div>
            <div class="group">
              <label>{{ $t("upsell.module") }}</label>
              <select type="text" v-model="onEndModule">
                <option :value="module" v-for="module of modules">{{ $t('upsell.modules.${module}') }}</option>
              </select>
            </div>
            <div v-if="onEndModule === 'ai'">
              <div class="group">
                <ListMultiSelect :bank="allCategories" :selected="upsell.onEnd.ai.categories"
                  :bank-title="$t('upsell.available_categories')" :selected-title="$t('upsell.recommended_categories')" />
              </div>
            </div>
            <div v-if="onEndModule === 'manual'">
              <div class="group">
                <ListMultiSelect :bank="allItems" :selected="upsell.onEnd.manual.items"
                  :bank-title="$t('upsell.available_categories')" :selected-title="$t('upsell.recommended_items')" />
              </div>
            </div>
          </div>

        </TabSection>
      </Tabs>

      <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
        <button class="save btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { Core } from "@/core/Core";
  import { mapActions } from "vuex";
  import ListMultiSelect from '@/components/tools/ListMultiSelect.vue';

  export default {
    name: "Upsell",

    components: { ListMultiSelect },

    data() {
      return {
        modules: ['deactivated', 'manual'],
        inventory: null,
        allModifiers: null,
        allCategories: null,
        allItems: null,
        upsell: {
          onModifiers: {
            activated: false,
            modifiers: []
          },
          onStart: {
            ai: {
              activated: false,
              categories: [],
            },
            manual: {
              activated: false,
              items: [],
            }
          },
          onEnd: {
            ai: {
              activated: false,
              categories: [],
            },
            manual: {
              activated: false,
              items: [],
            }
          }
        }

      }
    },

    computed: {
      onStartModule: {
        get() {
          if (this.upsell.onStart.ai.activated) {
            return 'ai'
          } else if (this.upsell.onStart.manual.activated) {
            return 'manual'
          } else {
            return 'deactivated'
          }
        },
        set(value) {
          this.upsell.onStart.ai.activated = value === 'ai';
          this.upsell.onStart.manual.activated = value === 'manual'
        }
      },
      onEndModule: {
        get() {
          if (this.upsell.onEnd.ai.activated) {
            return 'ai'
          } else if (this.upsell.onEnd.manual.activated) {
            return 'manual'
          } else {
            return 'deactivated'
          }
        },
        set(value) {
          this.upsell.onEnd.ai.activated = value === 'ai';
          this.upsell.onEnd.manual.activated = value === 'manual'
        }
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      let [inventory, allCategories, allItems, allModifiers] = await Promise.all([
        this.getInventory({ id: this.inventory.id }),
        Core.request('GET', '/api/entity/category/select', { inventory: this.inventory.id }),
        Core.request('GET', '/api/entity/item/select', { inventory: this.inventory.id }),
        Core.request('GET', '/api/entity/modifier/select', { inventory: this.inventory.id }),
      ]);

      Object.assign(this.upsell, inventory.upsell || {});
      this.allCategories = allCategories;
      this.allItems = allItems;
      this.allModifiers = allModifiers;

      this.upsell.onStart.ai.categories = this.upsell.onStart.ai.categories.map(id => this.mapIdToObject(id, this.allCategories)).filter(x => !!x);
      this.upsell.onEnd.ai.categories = this.upsell.onEnd.ai.categories.map(id => this.mapIdToObject(id, this.allCategories)).filter(x => !!x);
      this.upsell.onStart.manual.items = this.upsell.onStart.manual.items.map(id => this.mapIdToObject(id, this.allItems)).filter(x => !!x);
      this.upsell.onEnd.manual.items = this.upsell.onEnd.manual.items.map(id => this.mapIdToObject(id, this.allItems)).filter(x => !!x);
      this.upsell.onModifiers.modifiers = this.upsell.onModifiers.modifiers.map(id => this.mapIdToObject(id, this.allModifiers)).filter(x => !!x);

      if (!this.$store.getters.loggedUserHasModifyPermission) {
        window.lockFields();
      }
    },

    methods: {
      ...mapActions(["getInventory", "saveInventory"]),

      mapIdToObject(id, list) {
        return list.filter(e => e.id === id)[0] || null
      },

      async save() {
        let data = {
          upsell: JSON.parse(JSON.stringify(this.upsell))
        };
        data.upsell.onStart.ai.categories = this.upsell.onStart.ai.categories.map(e => e.id);
        data.upsell.onEnd.ai.categories = this.upsell.onEnd.ai.categories.map(e => e.id);
        data.upsell.onStart.manual.items = this.upsell.onStart.manual.items.map(e => e.id);
        data.upsell.onEnd.manual.items = this.upsell.onEnd.manual.items.map(e => e.id);
        data.upsell.onModifiers.modifiers = this.upsell.onModifiers.modifiers.map(e => e.id);

        let response = this.saveInventory({ id: this.inventory.id, data });
        if (response) {
          toast(this.$t("upsell.save_success"), "success");
          Object.assign(this.upsell, response.upsell);
        } else {
          toast(this.$t("inventory.error.save"), "error");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #upsellEdit {
    display: flex;
  }

  .section {
    margin-bottom: 30px;
  }
</style>
